import { Grid } from '@mui/material';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { useCasesGeneralForm } from './hook';

import FormView from '../../../../components/views/formView';
import { CasesGeneralFormProps } from './props';
import { CasesGeneralCallInfo } from './callInfo';
import { CasesGeneralClaims } from './claims';
import { CasesGeneralNotification } from './notificationClient';
import { CasesGeneralTypification } from './typification';

export const CasesGeneralForm = ({ showFormView }: CasesGeneralFormProps) => {
    const {
        casesGeneral,
        loading,
        handleSubmit,
        handleClean,
        setFormikCasesGeneralClaims,
        setFormikCasesGeneralNotification,
        setFormikCasesGeneralTypification,
        setFormikCasesGeneralCallInfo,
    } = useCasesGeneralForm();

    return (
        <>
            {showFormView && (
                <FormView
                    title={
                        casesGeneral && casesGeneral.id
                            ? 'Editar casos generales'
                            : 'Crear casos generales'
                    }
                />
            )}
            <CasesGeneralCallInfo
                data={casesGeneral?.callInfo}
                onChangeFormik={(formik) =>
                    setFormikCasesGeneralCallInfo(formik)
                }
            />
            <CasesGeneralClaims
                data={casesGeneral?.claims}
                onChangeFormik={(formik) => setFormikCasesGeneralClaims(formik)}
            />
            <CasesGeneralNotification
                data={casesGeneral?.notificationClient}
                onChangeFormik={(formik) =>
                    setFormikCasesGeneralNotification(formik)
                }
            />
            <CasesGeneralTypification
                data={casesGeneral?.typification}
                onChangeFormik={(formik) =>
                    setFormikCasesGeneralTypification(formik)
                }
            />

            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!casesGeneral || !casesGeneral.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
        </>
    );
};
